import React from 'react';
import { Card, Collapse } from 'react-bootstrap';

/**
 * Reusable collapsible card for form sections.
 * @param {string} title - Header label
 * @param {boolean} expanded - Whether the body is visible
 * @param {function} onToggle - Called when header is clicked
 * @param {React.ReactNode} [headerAction] - Optional content in header (e.g. filter); clicks do not toggle
 * @param {React.ReactNode} children - Card body content (e.g. form)
 */
const FormSectionCard = ({ title, expanded, onToggle, headerAction, children }) => (
  <Card className="form-section-card mb-3">
    <Card.Header
      className="form-section-header d-flex align-items-center justify-content-between flex-wrap gap-2"
      aria-expanded={expanded}
    >
      <div
        className="d-flex align-items-center flex-grow-1"
        onClick={onToggle}
        role="button"
        style={{ cursor: 'pointer', minWidth: 0 }}
      >
        <h5 className="mb-0">{title}</h5>
        <span className={`form-section-chevron ${expanded ? 'open' : ''}`} aria-hidden />
      </div>
      {headerAction != null ? (
        <div onClick={(e) => e.stopPropagation()} className="flex-shrink-0">
          {headerAction}
        </div>
      ) : null}
    </Card.Header>
    <Collapse in={expanded}>
      <div>
        <Card.Body>{children}</Card.Body>
      </div>
    </Collapse>
  </Card>
);

export default FormSectionCard;
